import React, {Fragment} from "react";
import VariantButton from "../../common/VariantButton";
import VariantDropdown from "../../common/VariantDropdown";

const Variants = ({
  selectedVariant,
  currentVariant,
  handleChangeVariant,
  options = [],
  selectedColor,
  variants,
  style = "button",
}) => {


  const getFilteredOptions = (name) => {
    const option = options.find((option) => option.name === name);
    if (!option) return [];
    const hasSelectedColour = Object.keys(selectedColor).length > 0;

    return option.values.filter((value) => {
      return variants.some((variant) => {
        const hasMatchingOption = (opt) => {
          return opt.name === name && opt.value === value;
        }

        if (hasSelectedColour) {
          // If there is a color option, filter based on color and other options
          const hasMatchingColor = variant.selectedOptions.some(
              (opt) => (opt.name === "Color" || opt.name === "Colour") && opt.value === selectedColor.name
          );

          return hasMatchingColor && variant.selectedOptions.some(hasMatchingOption);
        } else {
          return variant.selectedOptions.some(hasMatchingOption);
        }
      });
    });
  };

  // List of variant names
  const variantNames = [
    "Size",
    "Amount",
    "Opening",
    "Payment Options",
    "Length",
    "Fit",
    "Strength",
    "Shipping Country",
    "Style",
  ];
  return (
    <Fragment>
      {style === "button" && (
        variantNames.map((name) => (
          <VariantButton
            key={name}
            optionKey={name}
            title={`${name} : ${selectedVariant[`selected${name.replace(" ", "")}`]}`}
            variantKey={`selected${name.replace(" ", "")}`}
            currentVariant={selectedVariant[`selected${name.replace(" ", "")}`]}
            changeVariant={handleChangeVariant}
            options={getFilteredOptions(name)}
            selectedColor={selectedColor}
            selectedOptions={currentVariant?.selectedOptions}
            variants={variants}
          />
        ))
      )}
      {style === "dropdown" && (
        variantNames.map((name) => {
          const options = getFilteredOptions(name);
          if (options.length === 0) {
            return <></>;
          }
          return (
            <VariantDropdown
              key={name}
              optionKey={name}
              title={name}
              variantKey={`selected${name.replace(" ", "")}`}
              currentVariant={selectedVariant[`selected${name.replace(" ", "")}`]}
              changeVariant={handleChangeVariant}
              options={options}
              selectedColor={selectedColor}
              selectedOptions={currentVariant?.selectedOptions}
              variants={variants}
            />
          )
        })
      )}
    </Fragment>
  );
};

export default Variants;
